import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountComponent } from './account.component';
import { MasterComponent } from './master.component';
import {  AuthGuardService as AuthGuard } from '../../auth/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    component: AccountComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full'},
      {
        path: 'dashboard',
        canActivate: [AuthGuard] ,
        loadChildren: () =>
          import('../../dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: '',
        canActivate: [AuthGuard] ,
        loadChildren: () =>
          import('../../transactions/transactions.module').then((m) => m.TransactionsModule),
      },
      {
        path: '',
        canActivate: [AuthGuard] ,
        loadChildren: () =>
          import('../../settlements/settlements.module').then((m) => m.SettlementModule),
      },
      {
        path: '',
        canActivate: [AuthGuard] ,
        loadChildren: () =>
          import('../../reports/reports.module').then((m) => m.ReportsModule),
      },
      {
        path:'',
        canActivate:[AuthGuard],
        loadChildren:()=>
        import('../../products/products.module').then((m)=>m.ProductsModule),
      }
      ,
      {
        path:'',
        canActivate:[AuthGuard],
        loadChildren:()=>
        import('../../orders/orders.module').then((m)=>m.OrdersModule),
      },
      {
        path:'',
        canActivate:[AuthGuard],
        loadChildren:()=>
        import('../../payments/payments.module').then((m)=>m.PaymentsModule),
      },
      {
        path:'',
        canActivate:[AuthGuard],
        loadChildren:()=>
        import('../../vouchers/vouchers.module').then((m)=>m.VouchersModule),
      }

    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountMasterRoutingModule {}
